import { useState, useEffect } from 'react';
import {
  API_GET_ALL_ANNOUNCEMENTS,
  API_GET_ALL_TEAMS_ANNOUNCEMENTS
} from '../../../../api/announcementService';

/**
 * Custom hook to fetch announcements and teams announcements data
 * @returns {{ announcementById: Object, announcements: Object, loading: boolean }}
 */
export function useAnnouncementsData() {
  const [announcementData, setAnnouncementData] = useState({
    announcementById: {},
    announcements: null,
    loading: true
  });

  useEffect(() => {
    const fetchAnnouncementData = async () => {
      try {
        const [announcementsRes, teamsAnnouncementsRes] = await Promise.all([
          API_GET_ALL_ANNOUNCEMENTS(),
          API_GET_ALL_TEAMS_ANNOUNCEMENTS()
        ]);

        const announcementItems = announcementsRes?.data || [];
        const announcementById = Object.fromEntries(
          announcementItems.map((ann) => [ann.announcementId, ann])
        );

        // Map API response keys to expected structure
        const rawData = teamsAnnouncementsRes?.data || {};
        const normalizedData = {
          teamAnnouncements: rawData.teamConfigs || rawData.teamAnnouncements || [],
          defaultAnnouncement: rawData.defaultConfig || rawData.defaultAnnouncement
        };

        setAnnouncementData({
          announcementById,
          announcements: normalizedData,
          loading: false
        });
      } catch (error) {
        setAnnouncementData({
          announcementById: {},
          announcements: {},
          loading: false
        });
      }
    };

    fetchAnnouncementData();
  }, []);

  return announcementData;
}
